export default function AdminPagination({ page, totalPages, totalItems, pageSize, onPageChange }) {
  if (totalItems <= pageSize) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <nav className="admin-pagination" aria-label="Pagination">
      <span className="admin-pagination__info">
        {start}–{end} of {totalItems}
      </span>
      <div className="admin-pagination__controls">
        <button
          type="button"
          className="admin-btn admin-btn--ghost admin-btn--sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Previous
        </button>
        <span className="admin-pagination__page">
          Page {page} / {totalPages}
        </span>
        <button
          type="button"
          className="admin-btn admin-btn--ghost admin-btn--sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </nav>
  );
}
